var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListBreadCrumbWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 1.875C0.375 1.32272 0.822715 0.875 1.375 0.875H16.625C17.1773 0.875 17.625 1.32272 17.625 1.875V2.125C17.625 2.67728 17.1773 3.125 16.625 3.125H1.375C0.822715 3.125 0.375 2.67728 0.375 2.125V1.875Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 7.875C0.375 7.32272 0.822715 6.875 1.375 6.875H16.625C17.1773 6.875 17.625 7.32272 17.625 7.875V8.125C17.625 8.67728 17.1773 9.125 16.625 9.125H1.375C0.822715 9.125 0.375 8.67728 0.375 8.125V7.875Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 13.875C0.375 13.3227 0.822715 12.875 1.375 12.875H16.625C17.1773 12.875 17.625 13.3227 17.625 13.875V14.125C17.625 14.6773 17.1773 15.125 16.625 15.125H1.375C0.822715 15.125 0.375 14.6773 0.375 14.125V13.875Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBreadCrumbWhite);
export default __webpack_public_path__ + "static/media/list-bread-crumb-white.b2d5c587b7c9e4897993c2465240acdf.svg";
export { ForwardRef as ReactComponent };